import m from "../../../../geodata/es2015/region/world/middleEastUltra";
window.am4geodata_region_world_middleEastUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/middleEastUltra.js
// module id = null
// module chunks = 